import type { FormFields } from '@/entities/purchase-form';

type BuildLineText = {
    lines: FormFields['personalization']['frontLines'];
};
export const buildLineText = ({ lines = [] }: BuildLineText) => lines.map(line => line.text).join('|');
